import { optimizeImageUrl as importedOptimizeImageUrl } from "../images/optimizeImages";
/**
 * @hidden
 * @trackfunction
 */ export var optimizeImageUrl = function(image, isSSR) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return importedOptimizeImageUrl(image, isSSR, options);
};
export { setImageDPR, isTransformableImageUrl, optimizeProductImageUrl } from "../images/optimizeImages";
var optimizeImageUrlDefaultEmptyString = function(isSSR, imgUrl, options) {
    return imgUrl ? optimizeImageUrl({
        url: imgUrl,
        tags: []
    }, isSSR, options) || "" : "";
};
/**
 * @hidden
 * @trackfunction
 * @deprecated use optimizeImageUrl
 */ export var optimizeImageUrlString = function(url, isSSR) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return optimizeImageUrl({
        url: url,
        tags: []
    }, isSSR, options);
};
/**
 * @hidden
 * @trackfunction
 * @deprecated use optimizeImageUrl
 */ export var opt = function(isSSR, imgUrl) {
    return optimizeImageUrlDefaultEmptyString(isSSR, imgUrl);
};
/**
 * @hidden
 * @trackfunction
 * @deprecated use optimizeImageUrlFillSquare
 */ export var optFillSquare = function(dimension) {
    return function(isSSR, imgUrl) {
        return optimizeImageUrlDefaultEmptyString(isSSR, imgUrl, {
            width: dimension,
            height: dimension,
            resizeMethod: "fill",
            gravity: "auto"
        });
    };
};
/**
 * @hidden
 * @trackfunction
 * @deprecated use optimizeImageUrlWidth
 */ export var optWidth = function(width) {
    return function(isSSR, imgUrl) {
        return optimizeImageUrlDefaultEmptyString(isSSR, imgUrl, {
            width: width
        });
    };
};
/**
 * @hidden
 * @trackfunction
 * @deprecated use optimizeImageUrlHeight
 */ export var optHeight = function(height) {
    return function(isSSR, imgUrl) {
        return optimizeImageUrlDefaultEmptyString(isSSR, imgUrl, {
            height: height
        });
    };
};
